import React from 'react';
import icons from '../../../constants/icons';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import { Modal } from '@mui/material';
import { ReactSVG } from 'react-svg';
import Text from '../../../components/Text';
import Loader from '../../../components/Loader';
import { RowView } from '../../../components';
import Button from '../../../components/Button';
import { getContentKeyAccToLang } from '../../../utils/utils';
import { useSelector } from 'react-redux';

const NafathModal = ({ open, onClose, nafath_code, onTryAgain }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  const { authContent } = useSelector((state) => state.content);
  const { authLoading } = useSelector((state) => state.auth);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_wathq_verification?.data?.attributes, key, isArabic);
  };

  return (
    <Modal open={open} onClose={() => {}} className='flex items-center justify-center'>
      <div className='bg-white p-6 rounded-lg w-[90%] sm:w-1/2 md:w-1/3 flex flex-col items-center'>
        <ReactSVG src={icons.modal_success_icon} className='mb-6 mt-2' />

        <Text text={`${getContentKey('nafath_varification_text')} ${nafath_code || 0}`} size={fontSizes.h18} weight={TextWeight.bold} isCenter />

        {authLoading ? (
          <Loader className='w-8 h-8 mt-9' />
        ) : (
          <RowView className='gap-4 w-full'>
            <Button
              text={getContentKey('try_again')}
              className={'mt-6 my-2 w-full'}
              onClick={() => {
                onTryAgain();
              }}
            />
            <Button
              text={getContentKey('dismiss')}
              className={'mt-6 my-2 w-full'}
              onClick={() => {
                onClose();
              }}
            />
          </RowView>
        )}
      </div>
    </Modal>
  );
};

export default NafathModal;
